export default __webpack_public_path__ + "static/media/login image.21c58bcd.jpg";